import {
    FETCH_DELETE_SEARCHERS_REQUEST,
    FETCH_DELETE_SEARCHERS_SUCCESS,
    FETCH_DELETE_SEARCHERS_FAILURE,
} from '../../actions/searchers/delete-searcher-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteSearcherReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_SEARCHERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_SEARCHERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_SEARCHERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteSearcherReducer;